import { status } from '../../config.ts'
import { publicityPage1, publicityDetail } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/marketing/promotions?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, publicityPage1]
    }
  },
  {
    method: 'GET',
    path: '/marketing/promotions/1',
    reply: async () => {
      await wait()
      return [status.ok, publicityDetail]
    }
  },
  {
    method: 'POST',
    path: '/marketing/promotions',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/marketing/promotions/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/marketing/promotions/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
